import { h } from "@stencil/core";
export class Legend {
  render() {
    return (h("ion-item-group", null, h("slot", { name: "start" }), h("slot", null), h("slot", { name: "end" })));
  }
  static get is() { return "gl-legend"; }
  static get elementRef() { return "el"; }
}
//# sourceMappingURL=legend.js.map
